<section id="content" class="table-layout animated fadeIn"  ng-controller="AnalyticController" ng-init="init()" ng-contoller="" ng-class="loading ? 'loading' : ''">
    
    <aside class="chute chute-left chute250">
        <div class="allcp-form">
            <form ng-submit="filter()">
                <div class="form-group">
                    <label class="field-label control-label fw600" for="select">Rapor Türü </label>
                    <select class="select form-control gui-input" id="select" ng-model="filterData.type">
                        <option value="order">İş</option>
                        <option value="worker">Personel</option>
                        <option value="customer">Müşteri</option>
                    </select>
                </div>

                <div class="form-group" ng-if="filterData.type == 'worker'">
                    <label class="field-label control-label fw600" for="select">Personel </label>
                    <select class="select form-control gui-input" id="select" 
                        ng-model="filterData.worker"
                        ng-options="item as item.user.full_name for item in data.workers track by item.id"
                        >
                            <option value="">Tüm Personeller</option>
                    </select>
                </div>

                <div class="form-group" ng-if="filterData.type == 'customer'">                    
                    <label class="field-label control-label fw600" for="select">Müşteri </label>
                    <select class="select form-control gui-input" id="select" 
                        ng-model="filterData.customer"
                        ng-options="item as item.customer_name for item in data.customers track by item.id"
                        >
                        <option value="">Tüm Müşteriler</option>
                    </select>
                </div>

                <div class="form-group">
                    <label class="field-label control-label fw600" for="select">Zaman</label>
                    <input date-range-picker options="opts" class="form-control date-picker" type="text" ng-model="filterData.date" required/>
                </div>

                <hr>   

                <div ng-if="filterData.type == 'customer'">

                    <div class="form-group">
                        <label class="field-label control-label fw600" for="select">Filtre Türü </label>
                        <div class="radio-custom mb20">
                            <input type="radio" id="customer_work" name="customer_filter_type" 
                                value="customer_work" 
                                ng-model="filterData.customer_filter_type">
                            <label for="customer_work" class="pt5">Müşteri KargoDağılımı</label>
                        </div>
                        <div class="radio-custom mb20">
                            <input type="radio" id="customer_form" name="customer_filter_type" 
                                value="customer_form" 
                                ng-model="filterData.customer_filter_type">
                            <label for="customer_form" class="pt5">Müşteri Form Bilgileri</label>
                        </div>
                        <select class="select form-control gui-input" id="select" 
                            ng-if="filterData.customer_filter_type == 'customer_form'"
                            ng-model="filterData.form_id"
                            ng-init="filterData.form_id = data.forms[0]"
                            ng-options="item as item.name for item in data.forms track by item.id"
                            >
                        </select>
                    </div>
                </div>


                <div ng-if="filterData.type == 'worker'">
                    <div class="form-group">
                        <label class="field-label control-label fw600" for="select">Filtre Türü </label>

                        <div class="radio-custom mb20">
                            <input type="radio" id="worker_work_performance" name="worker_filter_type" 
                                value="general" 
                                ng-model="filterData.worker_filter_type">
                            <label for="worker_work_performance" class="pt5">Genel</label>
                        </div>

                        <div class="radio-custom mb20">
                            <input type="radio" id="worker_work_statu" name="worker_filter_type" 
                                value="worker" 
                                ng-model="filterData.worker_filter_type">
                            <label for="worker_work_statu" class="pt5">Kişi Bazında</label>
                        </div>

                        <select class="select form-control gui-input" id="select" 
                                ng-model="filterData.worker_filter_status">
                            <option value="all">KargoDurumuna Göre</option>
                            <!-- <option value="time">Zamana Göre</option> -->
                            <!-- <option value="distance">Mesafeye Göre</option> -->
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <button type="submit" class="btn btn-primary btn-block">Filtrele</button>
                </div>
            </form>
        </div>
    </aside>

    <div class="chute chute-center p20">
        <div class="center-block">
            
            <div class="panel mb20 p10">
                <div class="panel-body">
                    <div class="col-md-12 mb10">
						<canvas 
                            ng-if="filterData.worker_filter_type == 'worker'"
                            id="bar" class="chart chart-bar" 
                            chart-data="chart_data"
							style="width: 100%; height: 300px; margin: 0 auto"
							chart-labels="chart.labels" 
                            chart-legend="true" 
                            chart-series="chart.series"
							chart-click="onClick" 
                            chart-options="options">
						</canvas> 
						<canvas 
                            ng-if="filterData.worker_filter_type != 'worker'"
                            id="line" class="chart chart-line" 
                            chart-data="chart_data"
							style="width: 100%; height: 300px; margin: 0 auto"
							chart-labels="chart.labels" 
                            chart-legend="true" 
                            chart-series="chart.series"
							chart-click="onClick" 
                            chart-options="options">
						</canvas> 
	                </div>
                </div>
            </div>

            <div class="panel mb20 p10">
                
                <div class="panel-body ptn">
                    <a href="#" 
                        ng-click="export()" 
                        class="btn btn-primary pull-right mb15"
                        ng-if="filterData.type != 'worker'"> <i class="fa fa-reply"></i> Dışa Aktar</a>

                    <div class="table-responsive" ng-if="filterData.type == 'order' || (filterData.type == 'customer' && filterData.customer_filter_type == 'customer_work')">
                        <table class="table table-hover tc-checkbox-1 fs13">
                            <thead class="p20">
                                <tr class="bg-light">
                                    <th class="text-left">No</th>
									<th>Personel Bilgileri</th>
									<th>Müşteri Bilgileri</th>
									<!-- <th>Mesafe</th> -->
									<th>KargoSüresi</th>
									<th>Kargo Tarihi</th>
									<th>Oluşturma Tarihi</th>
									<th>KargoTürü</th>
									<th>Form</th>
									<!-- <th>Puan</th> -->
									<th>Durum</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr class="text-left" ng-repeat="item in chart.table">
                                <td class="text-left">#{{item.id}}</td>
                                <td>{{ item.worker.user.full_name }} <br> {{ item.worker.phone_number }} </td>
                                <td>
                                    <a 
                                        href="#"
                                        ng-if="item.customer" 
                                        ng-click="getCustomerDetails(item.customer.id)">{{ item.customer.customer_name }}</a><br>
                                    <span ng-if="!item.customer">
                                        -
                                    </span>
                                </td>

                                <!-- <td>{{ item.distance }} KM</td> -->
                                <td>{{ humanizeDuration(item.time) }}</td>
                                <td>{{ item.scheduled_time | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
                                <td>{{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
                                <td>{{ item.work_type ? item.work_type.name : '-' }}</td>
                                <td>{{ item.form ? item.form.name : '-' }}</td>
                                <!-- <td>{{ item.rate ? item.rate : '-' }}</td> -->
                                <td>
                                    <span 
                                        ng-if="item.status"
                                        ng-style="{'color': item.status.color }" 
                                        class="pull-right">
                                        {{ item.status.name }}</span>
                                    <span ng-if="!item.status">Created</span>	
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <div class="table-responsive" ng-if="filterData.type == 'customer' && filterData.customer_filter_type == 'customer_form'">
                        <table class="table table-hover tc-checkbox-1 fs13">
                            <thead class="p20">
                                <tr class="bg-light">
                                    <th class="text-left" ng-repeat="i in chart.form.fields">{{ i.field_name }}</th>
                                </tr>
                            </thead>
                            <tbody>
  
                            <tr ng-repeat="form in chart.table">

                                <td ng-repeat="table_header in chart.form.fields" ng-if="form.form_values.length > 0">
                                
                                    <span ng-repeat="item in form.form_values" ng-if="table_header.id == item.form_field_id">

                                        <span ng-if="table_header.field_type == 'image'">
                                            <a href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.value }}" target="__BLANK" ng-if="item.value.length > 0" >
                                                <img
                                                    ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.value }}" 
                                                    class="img-thumbnail" width="150px">
                                            </a>
                                            <span ng-if="item.value.length == 0">Resim Eklenmemiş</span>
                                        </span>
                                        <span ng-if="table_header.field_type != 'image' && table_header.field_type != 'date' && table_header.field_type != 'checkbox'">
                                            <span ng-if="item.value.length > 0">{{ item.value }}</span>
                                            <span ng-if="item.value.length == 0">Bilgi Girilmemiş</span>
                                        </span>
                                        <span ng-if="table_header.field_type == 'date'">
                                            <span ng-if="item.value.length > 0">{{ item.value | amUtc | amDateFormat:'MM/DD/YYYY' }}</span>
                                            <span ng-if="item.value.length == 0">Bilgi Girilmemiş</span>
                                        </span>
                                            
                                        <span ng-if="table_header.field_type == 'checkbox'">
                                            <span ng-if="item.value.length > 0" ng-repeat="i in getArrayVal(item.value) track by $index ">{{ i }} ,</span>
                                            <span ng-if="item.value.length == 0">Bilgi Girilmemiş</span>
                                        </span>

                                    </span>

                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>

                    <div class="table-responsive" ng-if="filterData.type == 'worker' && filterData.worker_filter_type == 'general'">
                        <table class="table table-hover fs13">
                            <thead class="p20">
                                <tr class="bg-light">
                                    <th class="text-left">Tarih</th>
                                    <th ng-repeat="item in chart.series">{{ item }}</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr class="text-left" ng-repeat="item in chart.labels" ng-init="rowIndex = $index">
                                <td class="text-left">{{ item }}</td>
                                <td ng-repeat="serie in chart.series" ng-init="columnIndex = $index">
                                    {{ chart_data[columnIndex][rowIndex] }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="table-responsive" ng-if="filterData.type == 'worker' && filterData.worker_filter_type == 'worker'">
                        <table class="table table-hover fs13">
                            <thead class="p20">
                                <tr class="bg-light">
                                    <th class="text-left">Kişi</th>
                                    <th ng-repeat="item in chart.series">{{ item }}</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr class="text-left" ng-repeat="item in chart.labels" ng-init="rowIndex = $index">
                                <td class="text-left">{{ item }}</td>
                                <td ng-repeat="serie in chart.series" ng-init="columnIndex = $index">
                                    {{ chart_data[rowIndex][columnIndex] }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

        </div>
    </div>
</section>
